import React from "react";
import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
} from "@material-ui/core";
import { red } from "@material-ui/core/colors";

// CSSスタイルを定義
const useStyles = makeStyles((theme) =>
  createStyles({
    content: {
      textAlign: "center",
    },
    text: {
      marginTop: theme.spacing(4),
      fontSize: 20,
      whiteSpace: "pre-line", // \nで改行用
    },
    button: {
      fontSize: 18,
    },
    isDestoryOk: {
      color: red[600],
      fontWeight: "bolder",
    },
  })
);

export default function ConfirmDialog(props) {
  const {
    open,
    onClose,
    onOk,
    okLabel = "OK",
    isDestructive = false,
    children,
  } = props;
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent className={classes.content}>
        <DialogContentText className={classes.text}>
          {children}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary" className={classes.button}>
          キャンセル
        </Button>

        <Button
          onClick={onOk}
          color="primary"
          className={classes.button}
          classes={isDestructive ? { textPrimary: classes.isDestoryOk } : {}}
        >
          {okLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
